import React from 'react';
import PropTypes from 'prop-types';
import emptyStateImage from '../../../../assets/images/emptytstate.svg';

const NoSearchResults = ({ pageType, minHeight = 'min-h-[60vh]' }) => {
  return (
    <div className={`flex items-center justify-center ${minHeight} `}>
      <div className="flex flex-col items-center justify-center text-center vamos-white">
        <img
          src={emptyStateImage}
          alt={`${pageType} empty state illustration`}
          className="mb-4"
        />
        <h2 className="font-sans text-2xl font-bold leading-tight text-center text-vamos-gray mb-1">
          No results. Try expanding your search.
        </h2>
      </div>
    </div>
  );
};

NoSearchResults.propTypes = {
  pageType: PropTypes.string.isRequired,
  minHeight: PropTypes.string,
};

export default NoSearchResults;
